import React, { useCallback, useRef, useState } from "react";
import ApplyModal from "./ApplyModal";
import { useTranslation } from "../../i18n/LanguageContext";
import "../Home/HomeQapex.css";
import { Icons, QapexNav, QapexFooter, useReveal } from "../Home/QapexChrome";

// Un'icona per posizione (i colori delle card sono quelli dei servizi della home)
const JOB_ICONS = ["i-shield", "i-code", "i-devices", "i-flow"];

const WorkWithUs = () => {
    const { t } = useTranslation();
    const rootRef = useRef(null);
    // null = modulo chiuso; stringa (anche vuota) = posizione preselezionata
    const [applyFor, setApplyFor] = useState(null);
    const closeApply = useCallback(() => setApplyFor(null), []);
    useReveal(rootRef);

    // Posizioni (testi tradotti; `id` è il valore inviato con la candidatura)
    const positions = t("workWithUs.positions");

    return (
        <div className="qx" ref={rootRef}>
            <Icons />
            <QapexNav t={t} />

            <section className="qa cpage-top">
                <div className="glow" />
                <div className="wrap">
                    <div className="split reveal in">
                        <div>
                            <div className="eyebrow">{t("workWithUs.eyebrow")}</div>
                            <h1 className="jobs-title">{t("workWithUs.heroTitle")} <span>{t("workWithUs.heroHighlight")}</span></h1>
                        </div>
                        <div className="jobs-side">
                            <p className="lead">{t("workWithUs.heroText")}</p>
                            <button type="button" className="btn btn-primary" onClick={() => setApplyFor("")}>{t("workWithUs.applyNow")}</button>
                        </div>
                    </div>
                </div>
            </section>

            <section className="services">
                <div className="wrap">
                    <div className="center reveal">
                        <h2>{t("workWithUs.openPositions")}</h2>
                    </div>
                    <div className="sgrid jobs">
                        {positions.map((job, i) => (
                            <article className="scard reveal" key={job.id}>
                                <div className="ic"><svg><use href={`#${JOB_ICONS[i % JOB_ICONS.length]}`} /></svg></div>
                                <h3>{job.title}</h3>
                                <p>{job.description}</p>
                                <button type="button" className="btn btn-dark" onClick={() => setApplyFor(job.id)}>{t("workWithUs.apply")}</button>
                            </article>
                        ))}
                    </div>
                </div>
            </section>

            <QapexFooter t={t} />

            {applyFor !== null && <ApplyModal preselectedPosition={applyFor} onClose={closeApply} />}
        </div>
    );
};

export default WorkWithUs;
